(function () {
  function targetFromHash() {
    if (!location.hash || location.hash.length < 2) return null;
    try {
      return document.getElementById(location.hash.slice(1));
    } catch (e) {
      return null;
    }
  }

  function isBlocked() {
    // Intro overlay (overflow:hidden) or an open menu/cart drawer can make
    // the browser's native hash-scroll silently fail or land short.
    if (document.documentElement.classList.contains('nasha-intro-active')) return true;
    var openDrawer = document.querySelector('.menu-drawer-container[open], #CartDrawer-Overlay ~ * cart-drawer:not(.is-empty)');
    if (document.querySelector('details[open].menu-drawer-container')) return true;
    return false;
  }

  function scrollToTarget(target, smooth) {
    if (!target) return;
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
  }

  function handleHash(smooth) {
    var target = targetFromHash();
    if (!target) return;

    if (!isBlocked()) {
      scrollToTarget(target, smooth);
      return;
    }

    var attempts = 0;
    var maxAttempts = 40; // ~4s at 100ms
    var poll = window.setInterval(function () {
      attempts += 1;
      if (!isBlocked()) {
        window.clearInterval(poll);
        scrollToTarget(target, smooth);
      } else if (attempts >= maxAttempts) {
        window.clearInterval(poll);
        scrollToTarget(target, smooth);
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      handleHash(false);
    });
  } else {
    handleHash(false);
  }

  // Catches same-page hash navigation regardless of how it happened
  // (native anchor jump, or a component like the menu drawer closing
  // itself before updating the hash).
  window.addEventListener('hashchange', function () {
    handleHash(true);
  });

  // Belt-and-suspenders: make sure the mobile menu drawer actually closes
  // when a nav link inside it is used, instead of staying open on top of
  // the page it just navigated to.
  document.addEventListener('click', function (evt) {
    var link = evt.target.closest('.menu-drawer a, #menu-drawer a');
    if (!link) return;
    var openDetails = link.closest('details[open]');
    if (openDetails) {
      openDetails.removeAttribute('open');
    }
  });
})();
